import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import {ErrorResponse} from "@/shared/timr";

export class PasswordForgottenPage {
	private readonly form: JQuery;

	constructor() {
		this.form = $("#passwordForgottenForm");
		$("#email").focus();

		this.form.on("submit", event => {
			event.preventDefault();
			this.sendPasswordForgottenForm();
		});
	}

	private redirectToLogin() {
		window.location.href = "/timr/recording/recording.html";
	}

	private sendPasswordForgottenForm() {
		$.ajax({
			url: "/timr/passwordForgotten.json",
			type: "POST",
			data: this.form.serialize(),
			success: () => {
				BootstrapModal.info({
					title: "passwordForgotten.sent.header",
					message: "passwordForgotten.sent",
					buttons: [{
						text: "passwordForgotten.navigateToLogin",
						action: () => this.redirectToLogin()
					}]
				});
			},
			error: (response: ErrorResponse) => {
				if (response.responseJSON) {
					if (response.responseJSON.fieldErrors) {
						BootstrapModal.error({
							message: response.responseJSON.fieldErrors[0].message
						});
					} else {
						BootstrapModal.error({
							message: response.responseJSON.message
						});
					}
				}
			}
		});
	}
}
